/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { messages as r } from "./index.mjs";
function t(a) {
  const e = a.replace(
    /^pager\.([a-z])/,
    (p, s) => "grid.pager" + s.toUpperCase()
  );
  return { messageKey: e, defaultMessage: r[e] };
}
export {
  t as pagerMessagesMap
};
